import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustMarquee } from "@/components/TrustMarquee";
import { TrustBadges } from "@/components/TrustBadges";
import { HealthPackages } from "@/components/HealthPackages";
import { Doctors } from "@/components/Doctors";
import { Locations } from "@/components/Locations";
import { BookingForm } from "@/components/BookingForm";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { useLenis } from "@/hooks/useLenis";

export default function Home() {
  useLenis();

  return (
    <div className="bg-bone">
      <Navbar />
      <Hero />
      <TrustMarquee />
      <TrustBadges />
      <HealthPackages />
      <Doctors />
      <Locations />
      <BookingForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
